export const locales = [
    { text: "Arabic", value: "ar" },
    { text: "English", value: "en" },
];
